import React, { useEffect, useState } from 'react';
import '../../src/assets/layout/icard.css';
import Axios from 'axios';

const DownloadICard = (props) => {
    const [qrcodeimage, setqrcodeimage] = useState(null);

    useEffect(() => {
        GetQrCode();
    }, [props.data?.id])

    const GetQrCode = () => {
        if (!props.data?.id) return;
        Axios.get(`/api/Participant/GetQrImage/${props.data.id}`).
            then(Response => {
                setqrcodeimage(Response.data);
            }).catch(() => {});
    }

    const capitalizeWords = (str) => {
        if (!str || str.length === 0) {
            return '';
        }
        return str
            .toLowerCase()
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const designation = props.data?.designation || '';
    const isDelegate = designation === 'DELEGATE';
    const isFaculty = designation === 'INTERNATIONAL FACULTY' || designation === 'NATIONAL FACULTY';
    const isCoordinator = designation === 'CO-ORDINATOR';
    const cardClass = isDelegate ? 'bgimgdelegateicard' : isFaculty ? 'bgimgfacultyicard' : isCoordinator ? 'bgimgcoordinatoricard' : 'bgimgdelegateicard';

    const cityName = props.data?.cityname ? capitalizeWords(props.data.cityname) : '';
    const countryName = props.data?.countryname === 'USA' ? props.data.countryname : capitalizeWords(props.data?.countryname || '');
    const locationText = cityName && countryName ? `${cityName}, ${countryName}` : (cityName || countryName || '');

    return (
        <div className={cardClass}>
            <div style={{ marginTop: "192px" }}>
                <h1 className='bgimgidcardH1'>{capitalizeWords(props.data?.fullName || '')}</h1>
                <h2 className='bgimgidcardH2'>{locationText}</h2>
                <div className='bgimgidcardQR'>
                    {qrcodeimage && qrcodeimage.length > 0 ?
                        <center><img src={`data:image/jpg;base64,${qrcodeimage}`} width="152" height="152" alt="QR Code" /></center>
                        : ""
                    }
                </div>
            </div>
        </div>
    )
};

export default DownloadICard;


